import { render, staticRenderFns } from "./ViewAddons.vue?vue&type=template&id=0ea6f38c&scoped=true&"
import script from "./ViewAddons.vue?vue&type=script&lang=js&"
export * from "./ViewAddons.vue?vue&type=script&lang=js&"
import style0 from "./ViewAddons.vue?vue&type=style&index=0&id=0ea6f38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea6f38c",
  null
  
)

export default component.exports